import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconStackedBarChartAxis2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="stacked-bar-chart-axis-2"><path d="M3.75 3C4.16421 3 4.5 3.33579 4.5 3.75V17.25C4.5 18.4926 5.50736 19.5 6.75 19.5H20.25C20.6642 19.5 21 19.8358 21 20.25C21 20.6642 20.6642 21 20.25 21H6.75C4.67893 21 3 19.3211 3 17.25V3.75C3 3.33579 3.33579 3 3.75 3Z" fill="currentColor"/><path d="M9.5 9C10.8807 9 12 10.1193 12 11.5V18H7V11.5C7 10.1193 8.11929 9 9.5 9Z" fill="currentColor"/><path d="M15.5 6C16.8807 6 18 7.11929 18 8.5V18H13V8.5C13 7.11929 14.1193 6 15.5 6Z" fill="currentColor"/></CentralIconBase>;
};

export default IconStackedBarChartAxis2;
